import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon, EnvelopeIcon, MapPinIcon, ClockIcon, ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';
import { CheckCircleIcon } from '@heroicons/react/24/solid';
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import { contactAPI } from '../utils/api';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.name || !formData.email || !formData.subject || !formData.message) {
      toast.error('Veuillez remplir tous les champs obligatoires');
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      await contactAPI.send(formData);
      toast.success('Message envoyé avec succès ! Nous vous répondrons sous 24h.');
      setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
    } catch (error) {
      console.error('Erreur envoi message:', error);
      toast.error(error.response?.data?.message || 'Erreur lors de l\'envoi du message');
    } finally {
      setIsSubmitting(false);
    }
  };

  const contactInfos = [
    { icon: PhoneIcon, title: 'Téléphone', value: '+228 91 29 11 11 | +228 91 80 73 65', detail: 'Lun-Ven, 8h-18h', link: 'tel:+22891291111' },
    { icon: EnvelopeIcon, title: 'Email', value: 'vadomxpress@gmail.com', detail: 'Réponse sous 24h', link: 'mailto:vadomxpress@gmail.com' },
    { icon: MapPinIcon, title: 'Adresse', value: 'Lomé, Togo', detail: 'Afrique de l\'Ouest', link: null },
    { icon: ClockIcon, title: 'Support', value: '7j/7', detail: '24h/24 pour les urgences', link: null },
  ];

  return (
    <div className="overflow-hidden bg-[#0a0a0a] min-h-screen">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-[#252525] to-[#374151]/30 text-white py-16 lg:py-20 overflow-hidden">
        
        <div className="container-custom relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center"
          >
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.2 }}
              className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6"
            >
              <ChatBubbleLeftRightIcon className="h-5 w-5" />
              <span className="text-sm font-medium">Nous contacter</span>
            </motion.div>
            
            <h1 className="text-4xl lg:text-5xl font-display font-bold mb-4">
              Contactez-nous
            </h1>
            <p className="text-xl text-white/90 max-w-2xl mx-auto">
              Une question ? Besoin d'aide ? Notre équipe est là pour vous.
            </p>
          </motion.div>
        </div>
        
        <div className="absolute bottom-0 left-0 right-0">
          <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 120L60 105C120 90 240 60 360 45C480 30 600 30 720 37.5C840 45 960 60 1080 67.5C1200 75 1320 75 1380 75L1440 75V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0Z" 
                  fill="white"/>
          </svg>
        </div>
      </section>

      <div className="container-custom py-12 lg:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Informations de contact */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="space-y-2"
          >
            {contactInfos.map((info, index) => (
              <motion.div
                key={info.title}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                whileHover={{ y: -3 }}
                className="bg-[#111111] rounded-2xl p-4 border border-[#252525] hover:border-[#F97316]/30 transition-all duration-300"
              >
                <div className="w-8 h-8 bg-[#F97316]/10 rounded-xl flex items-center justify-center mb-2">
                  <info.icon className="h-6 w-6 text-[#F97316]" />
                </div>
                <h3 className="font-semibold text-white text-lg mb-1">{info.title}</h3>
                {info.link ? (
                  <a href={info.link} className="text-[#AAAAAA] hover:text-[#F97316] transition-colors">
                    {info.value}
                  </a>
                ) : (
                  <p className="text-[#AAAAAA]">{info.value}</p>
                )}
                <p className="text-sm text-[#666666] mt-2">{info.detail}</p>
              </motion.div>
            ))}

            {/* Carte Devenir Smart 
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4 }}
              whileHover={{ y: -3 }}
              className="bg-gradient-to-br from-[#F97316] to-[#e8630a] rounded-2xl p-6 text-center"
            >
              <h3 className="font-bold text-white text-xl mb-2">Rejoignez les Smarts</h3>
              <p className="text-white/80 text-sm mb-4">
                Vous êtes prestataire ? Rejoignez notre réseau et développez votre activité.
              </p>
              <Link
                to="/become-smart"
                className="inline-block bg-white text-[#F97316] px-6 py-3 rounded-xl font-semibold text-sm hover:shadow-xl transition-all"
              >
                Devenir Smart →
              </Link>
            </motion.div>*/}
          </motion.div>

          {/* Formulaire */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-2"
          >
            <div className="bg-[#111111] rounded-2xl p-6 lg:p-8 border border-[#252525]">
              <h2 className="text-2xl font-bold text-white mb-6">Envoyez-nous un message</h2>
              
              <form onSubmit={handleSubmit} className="space-y-10">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-[#CCCCCC] mb-2">Nom complet *</label>
                    <input
                      type="text"
                      required
                      value={formData.name}
                      onChange={(e) => setFormData({...formData, name: e.target.value})}
                      className="w-full px-4 py-3 rounded-xl bg-[#0a0a0a] border border-[#252525] text-white placeholder-[#666666] focus:outline-none focus:ring-2 focus:ring-[#F97316] focus:border-transparent transition-all"
                      placeholder="votre nom"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-[#CCCCCC] mb-2">Email *</label>
                    <input
                      type="email"
                      required
                      value={formData.email}
                      onChange={(e) => setFormData({...formData, email: e.target.value})}
                      className="w-full px-4 py-3 rounded-xl bg-[#0a0a0a] border border-[#252525] text-white placeholder-[#666666] focus:outline-none focus:ring-2 focus:ring-[#F97316] focus:border-transparent transition-all"
                      placeholder="votre@email.com"
                    />
                  </div>
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-[#CCCCCC] mb-2">Téléphone</label>
                    <input
                      type="tel"
                      value={formData.phone}
                      onChange={(e) => setFormData({...formData, phone: e.target.value})}
                      className="w-full px-4 py-3 rounded-xl bg-[#0a0a0a] border border-[#252525] text-white placeholder-[#666666] focus:outline-none focus:ring-2 focus:ring-[#F97316] focus:border-transparent transition-all"
                      placeholder="+228 XX XX XX XX"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-[#CCCCCC] mb-2">Sujet *</label>
                    <select
                      required
                      value={formData.subject}
                      onChange={(e) => setFormData({...formData, subject: e.target.value})}
                      className="w-full px-4 py-3 rounded-xl bg-[#0a0a0a] border border-[#252525] text-white focus:outline-none focus:ring-2 focus:ring-[#F97316] focus:border-transparent transition-all"
                    >
                      <option value="">Sélectionnez un sujet</option>
                      <option>Demande d'information</option>
                      <option>Devenir Smart</option>
                      <option>Partenariat</option>
                      <option>Réclamation</option>
                      <option>Assistance technique</option>
                      <option>Autre</option>
                    </select>
                  </div>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-[#CCCCCC] mb-2">Message *</label>
                  <textarea
                    required
                    rows={6}
                    value={formData.message}
                    onChange={(e) => setFormData({...formData, message: e.target.value})}
                    className="w-full px-4 py-3 rounded-xl bg-[#0a0a0a] border border-[#252525] text-white placeholder-[#666666] focus:outline-none focus:ring-2 focus:ring-[#F97316] focus:border-transparent transition-all resize-none"
                    placeholder="Décrivez votre demande..."
                  />
                </div>
                
                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-[#F97316] text-white py-4 rounded-xl font-semibold hover:bg-[#e8630a] transition-all disabled:opacity-70 disabled:cursor-not-allowed"
                >
                  {isSubmitting ? 'Envoi en cours...' : 'Envoyer le message'}
                </motion.button>
              </form>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;